import { RpcService } from 'rpc';
const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@form-proc.rpc`,
    services: {
        login_survey: {
            parameters: [
                {
                    name: 'formdata',
                    type: 'object',
                    optional: false
                }
            ]
        },
        quick_comment: {
            parameters: [
                {
                    name: 'formdata',
                    type: 'object',
                    optional: false
                }
            ]
        },
        evaluation: {
            parameters: [
                {
                    name: 'formdata',
                    type: 'object',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
